import {RouteConfig, RouteDef} from 'common/src/modules/routing/routing.types';

function validateAppRoute({
  appRoute,
  routeDef,
}: {
  appRoute: RouteConfig;
  routeDef: RouteDef;
}): string | undefined {
  const errors: string[] = [];

  // Validate path parameters
  const pathParams = appRoute.pathParams || {};
  const missingPathParams = routeDef.pathParams
    .filter((paramDef) => !(paramDef.key in pathParams))
    .map((paramDef) => paramDef.key);

  if (missingPathParams.length > 0) {
    errors.push(`Missing path parameters: ${missingPathParams.join(', ')}`);
  }

  // Validate query parameters
  const queryParams = appRoute.queryParams || {};
  const missingQueryParams = routeDef.queryParams
    .filter((paramDef) => paramDef.required && !(paramDef.key in queryParams))
    .map((paramDef) => paramDef.key);

  if (missingQueryParams.length > 0) {
    errors.push(`Missing required query parameters: ${missingQueryParams.join(', ')}`);
  }

  return errors.length > 0 ? errors.join('\n') : undefined;
}

export default validateAppRoute;
